const imagesLoaded = require('imagesloaded');
import TOPICS from './topics';
import Swiper from 'swiper';
import mobileMenu from '../pages/home/mobileMenu';
import LAZY_DISP from '../plugins/lazydisp';
import CURRENT_NAV from "../plugins/currentNav";
import { SCROLLABLE_NAV } from '../plugins/scrollable-nav';

const [mq] = [ window.matchMedia('(max-width: 900px)')];

export default function MAIN() {
  
  mobileMenu();

  //lazydisp
  LAZY_DISP('[data-lazydisp]');

  // currentクラス付与
  CURRENT_NAV();

  //scrollable nav
  new SCROLLABLE_NAV('nav.local-nav');
  
  // Front banner animation title
  const frontBanner = document.querySelector('.banner-front');

  function slideAnime() {
    if (frontBanner) {
      $('.leftAnime').each(function () {
        var elemPos = $(this).offset().top - 50;
        var scroll = $(window).scrollTop();
        var windowHeight = $(window).height();
        if (scroll >= elemPos - windowHeight) {
          $(this).addClass("slideAnimeLeftRight");
          $(this).children(".leftAnimeInner").addClass("slideAnimeRightLeft");
        } else {
          $(this).removeClass("slideAnimeLeftRight");
          $(this).children(".leftAnimeInner").removeClass("slideAnimeRightLeft");
        }
      });
    }
  }

  // Sidebar
  if( !mq.matches ) {
    const sidebar = document.querySelector('.sidebar');
    window.addEventListener('scroll', () => {
      if (scrollY >= 300) sidebar.style = 'transform: translate(-65px, -50%);'
      else sidebar.style = 'transform: translate(65px, -50%);'
    });
  }


  // LOADER
  const splash = document.querySelector('.splash');
  const progressNumber = document.querySelector('.progress-text');
  const progressBar = document.querySelector('.progress-bar');
  let isLoaded = false;

  const imgLoad = imagesLoaded('body');//body内の画像を監視
  const imgTotal = imgLoad.images.length;//画像の総数を取得

  let imgLoaded = 0;//ロードした画像カウント
  let progressSpeed = 8;//プログレスバーの進むスピード 大きいほど速くなる
  let progressCount = 0;//ローディングの進捗状況 0〜100
  let progressResult = 0;//ローディングの進捗状況 0〜100

  //読み込み状況をアップデート
  let progressInit = setInterval(function () {
    updateProgress();
  }, 25);

  //画像を一つロードするたびにimgLoadedのカウントをアップ
  imgLoad.on('progress', function (instance, image) {
    imgLoaded++
  })

  //読み込み状況アップデート関数
  function updateProgress() {

    //ローディング演出用の計算
    progressCount += (imgLoaded / imgTotal) * progressSpeed;

    if (progressCount >= 100 && imgTotal > imgLoaded) {
      //カウントは100以上だが画像の読み込みが終わってない
      progressResult = 99;
    } else if (progressCount > 99.9) {
      //カウントが100以上になった
      progressResult = 100;
    } else {
      //現在のカウント
      progressResult = progressCount;
    }

    //ローディング進捗状況をプログレスバーと数字で表示
    progressBar.style.width = progressResult + '%';
    progressNumber.innerText = Math.floor(progressResult) + '%';

    //ローディング完了後 0.8秒待ってページを表示
    if (progressResult >= 100 && imgTotal == imgLoaded) {
      clearInterval(progressInit);
      setTimeout(function () {
        splash.classList.add('open');
        slideAnime();
        isLoaded = true;
      }, 800);
    }
    
    setTimeout(() => {
      if(isLoaded) splash.style.display = 'none';
    }, 1000)
  }

  // Toc
  TOPICS();

  // sales slider
  var swiper = new Swiper(".mySwiper", {
    spaceBetween: 10,
    slidesPerView: 4,
    freeMode: true,
    watchSlidesProgress: true,
  });
  var swiper2 = new Swiper(".mySwiper2", {
    spaceBetween: 10,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    thumbs: {
      swiper: swiper,
    },
  });
}